import _defineProperty from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
var initialState = {
  branches: null,
  favorite_branches: null,
  branch: null,
  regions: null,
  offices: [],
  meta_offices: null,
  meeting_room: null,
  meeting_rooms: null,
  retails: null,
  retail: null,
  remaining_hours: null,
  reservations: null
};
var space = createSlice({
  name: 'space',
  initialState: initialState,
  reducers: reducers
});
export var spaceActions = _objectSpread({}, space.actions);
export default space;